import { gql } from '@apollo/client'

import { PelagoError } from 'gql/fragments'

export const REFRESH_INTERCOM_TOKEN_MUTATION = {
  mutation: gql`
    mutation intercomRefreshToken {
      intercomRefreshToken {
        ... on IntercomToken {
          intercomJwt
        }
        ${PelagoError}
      }
    }
  `,
  mutationName: 'intercomRefreshToken',
}
